/** Domain ↔ locale mapping for production; localhost uses ?lang= or localStorage. */
export const LOCALE_CONFIG = {
  ro: {
    locale: "ro",
    domain: "asistentpersonal.ro",
    brand: "asistentpersonal.ro",
    brandShort: "asistentpersonal",
    htmlLang: "ro",
    dateLocale: "ro-RO",
  },
  hu: {
    locale: "hu",
    domain: "szemelyiasszisztens.hu",
    brand: "szemelyiasszisztens.hu",
    brandShort: "szemelyiasszisztens",
    htmlLang: "hu",
    dateLocale: "hu-HU",
  },
}

export const LOCALE_ORDER = ["ro", "hu"]

export function detectLocale() {
  if (typeof window === "undefined") return "ro"

  const host = window.location.hostname.replace(/^www\./, "")
  if (host === LOCALE_CONFIG.hu.domain || host.endsWith(`.${LOCALE_CONFIG.hu.domain}`))
    return "hu"
  if (host === LOCALE_CONFIG.ro.domain || host.endsWith(`.${LOCALE_CONFIG.ro.domain}`))
    return "ro"

  const q = new URLSearchParams(window.location.search).get("lang")
  if (q === "hu" || q === "ro") return q

  const stored = localStorage.getItem("dev_locale")
  if (stored === "hu" || stored === "ro") return stored

  const envDefault = process.env.REACT_APP_DEFAULT_LOCALE
  if (envDefault === "hu" || envDefault === "ro") return envDefault

  return "ro"
}

export function getLocaleConfig(locale) {
  return LOCALE_CONFIG[locale] || LOCALE_CONFIG.ro
}

export function isLocalDevHost() {
  if (typeof window === "undefined") return false
  const h = window.location.hostname
  return h === "localhost" || h === "127.0.0.1"
}
